import { ProcessGeneral } from 'api/endpoints/processes';

export function hasOrderEntryLicense(draft?: ProcessGeneral) {
  return draft?._links?.['searchOrderEntryScenarios'] !== undefined;
}
